import React from 'react';
import { Link } from 'react-scroll';

function App() {
  return (
    <div>
      <nav className="navbar navbar-expand-lg">
        <div className="container-fluid fist">
        <a href="/">
  <img className="logo" src="/images/logo.png" alt="Logo" />
</a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav mx-auto">
              <li className="nav-item">
                <Link
                  to="aboutme"
                  // smooth={true}
                  // duration={500}
                  className="nav-link active little-malio-font"
                >
                  About Me
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="skills"
                  // smooth={true}
                  // duration={500}
                  className="nav-link active little-malio-font"
                >
                  Skills
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="project"
                  // smooth={true}
                  // duration={500}
                  className="nav-link active little-malio-font"
                >
                  Project
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="contact"
                  // smooth={true}
                  // duration={500}
                  className="nav-link active little-malio-font"
                >
                  Contact Me
                </Link>
              </li>
            </ul>
            <button className="btn1 little-malio-font" type="submit">
              Resume <i className="fas fa-download"></i>
            </button>
          </div>
        </div>
      </nav>
    </div>
  );
}

export default App;
